import { css } from 'styled-components';
import { every, isPlainObject, isArray, pick, omit, isNumber } from 'lodash';

/*
  const Example = styled(View)`
    background-color: white;

    ${withModifiers('alt')`
      background-color: black;
    `};
  `;

  <Example /> (will be white)
  <Example alt /> (will be black)
*/
export const withModifiers = (...modifiers) => (...styles) => (props) => {
  const match = every(modifiers, (modifier) => props[modifier]);

  if (!match) {
    return null;
  }

  return css(...styles);
};

export function pickStyles(styles, ...props) {
  if (isPlainObject(styles)) {
    return pick(styles, props);
  }

  if (isArray(styles)) {
    return styles.reduce((picked, styles) => {
      return { ...picked, ...pick(styles, props) };
    }, {});
  }
}

export function omitStyles(styles, ...props) {
  if (isPlainObject(styles)) {
    return omit(styles, props);
  }

  if (isArray(styles)) {
    return styles.reduce((picked, styles) => {
      return { ...picked, ...omit(styles, props) };
    }, {});
  }
}

export function normalize(value) {
  if (isNumber(value)) {
    return value + 'px';
  }
  return value;
}
